(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tab-box"] && !Shopify.designMode) return;
  try {
    (function () {
    function activate(box, index) {
      var btns = box.querySelectorAll('.tab-box__btn');
      var panels = box.querySelectorAll('.tab-info');
      btns.forEach(function (b, i) {
        var on = i === index;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });
    }

    function build(box) {
      var nav = box.querySelector('.tab-box__nav');
      var panels = box.querySelectorAll('.tab-info');
      nav.innerHTML = '';
      panels.forEach(function (p, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tab-box__btn';
        btn.setAttribute('role', 'tab');
        btn.textContent = p.getAttribute('data-title') || 'Tab ' + (i + 1);
        btn.addEventListener('click', function () { activate(box, i); });
        nav.appendChild(btn);
      });
      if (panels.length) activate(box, 0);
    }

    function init(root) {
      (root || document).querySelectorAll('.tab-box').forEach(build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var box = e.target.closest('.tab-box');
      if (!box) return;
      var panel = e.target.classList.contains('tab-info') ? e.target : e.target.querySelector('.tab-info');
      if (!panel) return;
      var all = Array.prototype.slice.call(box.querySelectorAll('.tab-info'));
      var idx = all.indexOf(panel);
      if (idx > -1) activate(box, idx);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
